import $ from 'jquery';
import 'slick-carousel';

function slickMain() {
  /*var elem = $('#slick-main').not('.slick-initialized');
  if (elem.length > 0) {
    elem.on('init', function () {
    }).slick({
      dots: false,
      speed: 2000,
      arrows: false,
      autoplay: true,
      infinite:true,
      pauseOnHover: false,
      fade:true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }*/
}

function slickSliderHome() {
  var elem = $('.home-carousel').not('.slick-initialized');
  if (elem.length > 0) {
    elem.on('init', function () {
    }).slick({
      dots: false,
      arrows: true,
      autoplay: true,
      infinite:false,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 767,
               settings: {
                      dots: true,
                      arrow:false
                  }
          }
      ]
    });
  }
}


function slickTestimonies() {
  var elem = $('.block-testimonies .slick-slider').not('.slick-initialized');
  if (elem.length > 0) {
    elem.on('init', function () {
    }).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      dots: true,
      responsive: [
          {
              breakpoint: 767,
              settings: 'unslick'
          }
      ]
    });
  }
}


function slickLastNews() {
  var elem = $('.block_last_news .list').not('.slick-initialized');
  if (elem.length > 0) {
    elem.on('init', function () {
    }).slick({
      dots: true,
      arrows: false,
      autoplay: true,
      infinite:false,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
          {
              breakpoint: 767,
               settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      infinite: false,
                      dots: true
                  }
          }
      ]
    });
  }
}


function slickSuppliers() {
  var elem = $('.block_suppliers .slick-slider').not('.slick-initialized');
  if (elem.length > 0) {
    elem.on('init', function () {
    }).slick({
      dots: false,
      arrows: false,
      infinite: false,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 7000,
      waitForAnimate: false,
      edgeFriction: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      cssEase: 'linear',
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 767,
               settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      infinite: false,
                      dots: false
                  }
          }
      ]
    });
  }
}


function slickReferences() {
  var elem = $('.block_references .slick-slider[dir=ltr]').not('.slick-initialized');
  if (elem.length > 0) {
    elem.on('init', function () {
    }).slick({
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 7000,
      waitForAnimate: false,
      edgeFriction: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      cssEase: 'linear',
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 767,
               settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      infinite: false,
                      dots: false
                  }
          }
      ]
    });
  }

  var elem = $('.block_references .slick-slider[dir=rtl]').not('.slick-initialized');
  if (elem.length > 0) {
    elem.on('init', function () {
    }).slick({
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 7000,
      waitForAnimate: false,
      edgeFriction: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      cssEase: 'linear',
      rtl: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 767,
               settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      infinite: false,
                      dots: false
                  }
          }
      ]
    });
  }
}


function slickKeyfigures() {
  var elem = $('.block_keyfigures .slick-slider').not('.slick-initialized');
  if (elem.length > 0) {
    elem.on('init', function () {
    }).slick({
      dots: false,
      arrows: false,
      infinite: false,
      cssEase: 'linear',
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 767,
               settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      infinite: false,
                      dots: false
                  }
          }
      ]
    });
  }
}

var slickGutenbergBlocks = function(){
  var elem = $('.slider-4').not('.slick-initialized');
  if (elem.length > 0) {
    elem.on('init', function () {
      }).slick({
      infinite: true,
      slidesToShow: 4,
      lazyLoad: 'ondemand',
      rows: 0,
      arrows: false,
      autoplay: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots:true,
          }
        }
      ]
    });
  }

  var elem = $('.slider-3').not('.slick-initialized');
  if (elem.length > 0) {
    elem.on('init', function () {
      }).slick({
      infinite: true,
      slidesToShow: 3,
      lazyLoad: 'ondemand',
      rows: 0,
      arrows: false,
      autoplay: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots:true,
          }
        }
      ]
    });
  }
}

function slickReferencesLikeSuppliers() {
  var elem = $('.block_references-like-suppliers .slick-slider').not('.slick-initialized');
  if (elem.length > 0) {
    elem.on('init', function () {
    }).slick({
      dots: false,
      arrows: false,
      infinite: false,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 7000,
      waitForAnimate: false,
      edgeFriction: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      cssEase: 'linear',
      slidesToShow: 6,
      slidesToScroll: 1,
      responsive: [
          {
              breakpoint: 767,
               settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      infinite: false,
                      dots: false
                  }
          }
      ]
    });
  }
}


var init = function () {
  slickMain();
  slickSliderHome();
  slickTestimonies();
  slickLastNews();
  slickSuppliers();
  slickReferences();
  slickKeyfigures();
  slickGutenbergBlocks();
  slickReferencesLikeSuppliers();
}

var tresize = function(){
  slickMain();
  slickSliderHome();
  slickTestimonies();
  slickLastNews();
  slickSuppliers();
  slickReferences();
  slickKeyfigures();
  slickGutenbergBlocks();
  slickReferencesLikeSuppliers();
}

$(window).on('load', function () {
  init();
});

$(window).on('resize', function () {
  tresize();
});
